export const NUMBR_PARTNER_ID = 829;
